import { Link } from 'react-router-dom'
import Header from '@/components/Header'
import { usePageTitle } from '@/components/usePageTitle'

const YEAR = new Date().getFullYear()

export default function NotFound() {
  usePageTitle('Page Not Found')
  return (
    <div className="relative flex min-h-svh flex-col bg-black text-white">
      <Header tone="light" />
      <main className="flex flex-1 flex-col items-center justify-center px-6 pt-36 text-center">
        <h1 className="font-light">Page not found :(</h1>
        <h3 className="mt-12 font-light italic">Looking for a color? Try the registry.</h3>
        <h2 className="mt-6">
          <Link to="/registry">Search Registry</Link>
        </h2>
      </main>
      <footer className="px-[36px] pb-[27px] font-body text-sm font-extralight">
        Copyright © {YEAR} ColorMark™
        <br />
        All Rights Reserved
      </footer>
    </div>
  )
}
